const style = {
  nestedList: { backgroundColor: '#f7f7f7', padding: 0 },
  activeMarkerType: {
    backgroundColor: 'rgba(78, 163, 216, 0.2)',
    borderRight: '5px solid rgb(78, 163, 216)'
  }
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMarkerTypes/style.js